/**
 * PublishDialog — dialog for reviewing and publishing all pending inventory counts across locations.
 */
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { CloudArrowUp } from "@phosphor-icons/react";

export function PublishDialog({
  open, onOpenChange,
  pendingSummary, totalPendingCounts,
  saving, onPublish
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading tracking-wide">PUBLISH INVENTORY</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          <p className="text-muted-foreground">
            Review your inventory counts before publishing to the database.
          </p>

          {pendingSummary.length > 0 ? (
            <div className="space-y-2">
              {pendingSummary.map(s => (
                <div key={s.locationId} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
                  <span className="font-medium">{s.locationName}</span>
                  <div className="flex items-center gap-3 text-sm">
                    <span>{s.productCount} products</span>
                    {s.prepCount > 0 && <span>{s.prepCount} prep items</span>}
                  </div>
                </div>
              ))}
              <div className="flex items-center justify-between p-3 bg-primary/10 rounded-lg border border-primary/20">
                <span className="font-semibold">Total</span>
                <span className="font-semibold">{totalPendingCounts} items</span>
              </div>
            </div>
          ) : (
            <p className="text-center text-muted-foreground py-4">No pending counts to publish.</p>
          )}
        </div>
        <DialogFooter className="mt-6">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onPublish}
            disabled={saving || totalPendingCounts === 0}
            className="bg-green-600 hover:bg-green-700"
            data-testid="confirm-publish-btn"
          >
            <CloudArrowUp size={18} className="mr-2" />
            {saving ? "Publishing..." : "Publish All"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
